import { Query } from 'system/query/Query';

export function MakeDrilldownRangeQuery(fieldID:string, startValue:string|number, startLabel:string, endValue:string|number|undefined, endLabel:string|undefined) {
  if (!fieldID || startValue === undefined || startValue === null) {
    return null;
  }

  let label = startLabel;

  let query: any = {
    op: ">=",
    value: startValue,
    field: fieldID
  };

  if (endValue !== undefined && endValue !== null) {
    label = `${label} to ${endLabel}`;
    query = {
      op: "and",
      values: [
        {
          op: ">=",
          value: startValue,
          field: fieldID
        },
        {
          op: "<",
          value: endValue,
          field: fieldID
        }
      ]
    }
  } else {
    label = `After ${label}`;
  }

  return {
    title: label,
    query: new Query({
      query: query
    })
  };
}

// Builds a query that filters by the node selected given a histogram result, a fieldId, and a selected index.
export function MakeDrilldownQueryFromHistogramIndex(histogram:any, fieldID:string, selectedIndex:number) {
  let startValue = histogram?.keys?.[selectedIndex];
  const startLabel = histogram?.labels?.[selectedIndex] + "";
  let endValue = histogram?.keys?.[selectedIndex + 1];
  const endLabel = histogram?.labels?.[selectedIndex + 1] + "";

  // The API will send back timestamps in UTC (in the `histogram.keys`).  We need to make sure we
  // convert them back to local time when we send them back to the API.
  if (typeof startValue === "string"
    && !isNaN(Date.parse(startValue))) {
      let newStartValue = new Date(startValue);
      const timezoneOffset = newStartValue.getTimezoneOffset() * 60 * 1000;
      newStartValue = new Date(newStartValue.getTime() - timezoneOffset);
      startValue = newStartValue.toISOString();
  }
    if (typeof endValue === "string"
      && !isNaN(Date.parse(endValue))) {
        let newEndValue = new Date(endValue);
        const timezoneOffset = newEndValue.getTimezoneOffset() * 60 * 1000;
        newEndValue = new Date(newEndValue.getTime() - timezoneOffset);
        endValue = newEndValue.toISOString();
  }

  return MakeDrilldownRangeQuery(fieldID, startValue, startLabel, endValue, endLabel);
}
